/*
 * Canonical URLs, as the server's snapshots and the SEO Edge Function write
 * them (docs/PHASE4.md, decision P2): the page's path, plus `?halaman=N` on
 * page 2 and later of a paginated listing, and nothing else. Tracking
 * parameters (utm_*, fbclid, gclid ...), filters and sort orders never reach
 * a canonical link or a share link.
 */

export const PAGE_PARAM = 'halaman';

/**
 * The page number a listing URL asks for: `{ page, canonical }`. `page` is 1
 * when there is none; `canonical` is false when the parameter is present but
 * not spelt the one canonical way (a whole number of 2 or more, no leading
 * zeros): ?halaman=1, ?halaman=02, ?halaman=abc. Same rules as
 * netlify/edge-functions/lib/seoCore.js `pageOf`.
 */
export function pageFromSearch(search) {
  const params = search instanceof URLSearchParams ? search : new URLSearchParams(search || '');
  const all = params.getAll(PAGE_PARAM);
  if (!all.length) return { page: 1, canonical: true };
  const raw = all[0].trim();
  const n = /^\d{1,6}$/.test(raw) ? Number(raw) : 1;
  const page = n >= 2 ? n : 1;
  return { page, canonical: all.length === 1 && page >= 2 && raw === String(page) };
}

/** "/kategori/serum", 3 -> "/kategori/serum?halaman=3"; page 1 is the bare path. */
export function canonicalPath(pathname, page = 1) {
  return page >= 2 ? `${pathname}?${PAGE_PARAM}=${page}` : pathname;
}

/** The absolute canonical URL of a page on this site. */
export function canonicalUrl(pathname, page = 1, origin = window.location.origin) {
  return `${origin}${canonicalPath(pathname, page)}`;
}

/**
 * Which page (and page number) a location shows: the key the snapshot
 * handoff compares, so going from page 1 to page 2 of a listing counts as
 * leaving the snapshot's page.
 */
export const pageKey = (pathname, search) => canonicalPath(pathname, pageFromSearch(search).page);
